import {h, Fragment} from "preact"
import { useResponse, AutocompleteElement, Keywords, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder, hideQuickAdd, showQuickAdd, hoverShowQuickAdd } from "../helpers"
import SubmitButton from "./elements/SubmitButton"
import Swatches from "./Swatches"
import AutocompleteProduct from "./AutocompleteProduct"
import Sizes from "./Sizes"
import NoResults from './NoResults'
import useRelatedData from './useRelatedData'
import { useEffect, useMemo } from "preact/hooks"

export default function Autocomplete() {
    const { products, keywords } = useResponse()
    const { format } = useCurrencyFormatting()
    var { swatchData } = useRelatedData();
    

    function blockEnter(e) {
        if (e.key === 'Enter') {
            e.preventDefault(); // Stop default behavior
            e.stopPropagation(); // Stop bubbling up to parent elements
            return false;
        }
    }

    if (!products?.hits?.length && !keywords?.hits?.length) {
        if( document.querySelector("#WebSearch #txt_search").value !== '') {
            document.querySelector("#WebSearch").classList.add("no-found-results")
        }
        document.querySelector("button.search-arrow").classList.remove("has-results");
        document.querySelector("button.search-arrow").disabled = true;
        document.querySelector("#WebSearch #txt_search").addEventListener('keydown', blockEnter);
        return
    } else {
        document.querySelector("button.search-arrow").disabled = false;
        document.querySelector("button.search-arrow").classList.add("has-results");
        document.querySelector("#WebSearch #txt_search").removeEventListener('keydown', blockEnter);
        document.querySelector("#WebSearch").classList.remove("no-found-results")
    }

    useEffect(()=>{
        document.querySelector("#txt_search[data-nosto-element='search-input']").addEventListener("input", function(){
            //console.log("INSIDE INPUT IS ", document.querySelector("#txt_search[data-nosto-element='search-input']").value)
            if(document.querySelector("#txt_search[data-nosto-element='search-input']").value == ""){
                document.querySelector("button.search-arrow").classList.remove("has-results");
                document.querySelector("button.search-arrow").disabled = true;
            }
        })
    }, [])

    // console.log("autocomplete", keywords?.hits?.[0])

    return (
        <div
            class="ns-autocomplete ns-absolute ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-background-white ns-border-box ns-mx-auto"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100 ns-mt-sm-auto">
                <div class="ns-d-flex ns-flex-column ns-flex-sm-row">
                    
                        <div
                            class="ns-autocomplete-keywords"
                        >
                            <div class="ns-autocomplete-header">{keywords?.hits?.length > 0 && "Suggestions"}</div>
                            <div class="ns-d-flex ns-flex-column">
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                />
                            </div>
                            {!products?.hits?.length && <SubmitButton text="See all search results" />}
                        </div>
                    
                    {products?.hits?.length > 0 ? (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                            {/* <div class="ns-color-black ns-py-2 ns-px-4 ns-font-medium ns-font-4">
                                Products
                            </div> */}
                            <div class="ns-products-wrapper">
                                {products?.hits?.map(product => {
                                    return <AutocompleteProduct product={product} key={product.productId || index} swatchData={ swatchData } />
                                })}
                            </div>
                            <SubmitButton text="See all search results" />
                        </div>
                    ):
                        <NoResults />
                    }
                </div>
            </div>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit?._highlight?.keyword ? (
                <span
                    dangerouslySetInnerHTML={{
                        __html: hit._highlight.keyword
                    }}
                ></span>
            ) : (
                hit.keyword
            )}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-keyword">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}
